export enum REVENUE_RANGE {
  ABOVE_FIVE_THOUSAND = 'ABOVE_FIVE_THOUSAND',
  BETWEEN_ONE_AND_TWO = 'BETWEEN_ONE_AND_TWO',
  BETWEEN_THREE_AND_FIVE = 'BETWEEN_THREE_AND_FIVE',
  BETWEEN_TWO_AND_THREE = 'BETWEEN_TWO_AND_THREE',
  UNDER_THOUSAND = 'UNDER_THOUSAND',
}
export const CONST_REVENUE_RANGE = Object.values(REVENUE_RANGE);

export enum ADMIN_ROLES {
  ADMIN_NORMAL = 'ADMIN_NORMAL',
  ADMIN_SUPER = 'ADMIN_SUPER',
}
export const CONST_ADMIN_ROLES = Object.values(ADMIN_ROLES);

export enum KB_MEDIUM_CATEGORY {
  F01 = 'F01',
  F02 = 'F02',
  F12 = 'F12',
  F14 = 'F14',
  F15 = 'F15',
  F10 = 'F10',
  F16 = 'F16',
  F04 = 'F04',
  F07 = 'F07',
}
export const CONST_KB_MEDIUM_CATEGORY = Object.values(KB_MEDIUM_CATEGORY);

export enum OPERATION_TIME {
  BREAKFAST = 'BREAKFAST',
  DINNER = 'DINNER',
  LATE_NIGHT = 'LATE_NIGHT',
  LUNCH = 'LUNCH',
}
export const CONST_OPERATION_TIME = Object.values(OPERATION_TIME);

export enum BRAND_CONSULT {
  NEW_CONSULT = 'NEW_CONSULT',
  CONSULT_DROPPED = 'CONSULT_DROPPED',
  CONSULT_COMPLETE = 'CONSULT_COMPLETE',
  CONSULT_CONTRACTED = 'CONSULT_CONTRACTED',
  CONSULT_CANNOT_CONTACT = 'CONSULT_CANNOT_CONTACT',
  CONSULT_WILL_MEET = 'CONSULT_WILL_MEET',
  CONSULT_MEETING_COMPLETE = 'CONSULT_MEETING_COMPLETE',
  CONSULT_CONTRACT_IN_PROG = 'CONSULT_CONTRACT_IN_PROG',
  CONSULT_MEETING_SECOND = 'CONSULT_MEETING_SECOND',
  CONSULT_CALL_LATER = 'CONSULT_CALL_LATER',
  CONSULT_MEETING_NO_SHOW = 'CONSULT_MEETING_NO_SHOW',
}

export const CONST_BRAND_CONSULT = Object.values(BRAND_CONSULT);

export enum BRAND_CONSULT_KOREAN {
  NEW_CONSULT = '신규 상담 신청',
  CONSULT_DROPPED = '드랍',
  CONSULT_COMPLETE = '상담 완료',
  CONSULT_CONTRACTED = '계약완료',
  CONSULT_CANNOT_CONTACT = '연락실패',
  CONSULT_WILL_MEET = '미팅예정',
  CONSULT_MEETING_COMPLETE = '미팅완료',
  CONSULT_CONTRACT_IN_PROG = '계약진행',
  CONSULT_MEETING_SECOND = '2차미팅',
  CONSULT_CALL_LATER = '재통화요청',
  CONSULT_MEETING_NO_SHOW = '노쇼',
}

export const CONST_BRAND_CONSULT_KOREAN = Object.values(BRAND_CONSULT_KOREAN);

export enum FNB_OWNER {
  CUR_FNB_OWNER = 'CUR_FNB_OWNER',
  NEW_FNB_OWNER = 'NEW_FNB_OWNER',
}
export const CONST_FNB_OWNER = Object.values(FNB_OWNER);

export enum DELIVERY_OR_RESTAURANT {
  DELIVERY_SPACE_BEST = 'DELIVERY_SPACE_BEST',
  DELIVERY_SPACE_EQUAL_RESTAURANT = 'DELIVERY_SPACE_EQUAL_RESTAURANT',
  DELIVERY_SPACE_NOT_GOOD = 'DELIVERY_SPACE_NOT_GOOD',
}
export const CONST_DELIVERY_OR_RESTAURANT = Object.values(
  DELIVERY_OR_RESTAURANT,
);

export enum CUSTOMER_PAIN_POINT {
  DIFFICULT_ENV = 'DIFFICULT_ENV',
  HIGH_REV_LOW_PROFIT = 'HIGH_REV_LOW_PROFIT',
  NEED_NEW_MENU = 'NEED_NEW_MENU',
  RECENT_LOW_REVENUE = 'RECENT_LOW_REVENUE',
  UNSTABLE_REVENUE = 'UNSTABLE_REVENUE',
}
export const CONST_CUSTOMER_PAIN_POINT = Object.values(CUSTOMER_PAIN_POINT);

export enum IP_STATUS {
  IP_ABUSE = 'IP_ABUSE',
}
export const CONST_IP_STATUS = Object.values(IP_STATUS);

export enum ADMIN_STATUS {
  ONLINE = 'ONLINE',
  REJECTED = 'REJECTED',
  WAITING = 'WAITING',
}
export const CONST_ADMIN_STATUS = Object.values(ADMIN_STATUS);

export enum TENTATIVE_OPEN_OPTION {
  PREP_PROCESSING = 'PREP_PROCESSING',
  START_WITHIN_TWO_MONTH = 'START_WITHIN_TWO_MONTH',
  STILL_LOOKING = 'STILL_LOOKING',
  STILL_WONDERING = 'STILL_WONDERING',
}
export const CONST_TENTATIVE_OPEN_OPTION = Object.values(TENTATIVE_OPEN_OPTION);

export enum STORE_TYPE {
  RESTAURANT = '매장',
  DELIVERY = '배달',
}
export const CONST_STORE_TYPE = Object.values(STORE_TYPE);

export enum KB_MEDIUM_CATEGORY_KOREAN {
  F01 = '주점',
  F02 = '기타외국식',
  F04 = '분식',
  F07 = '양식',
  F10 = '일식',
  F12 = '중식',
  F14 = '커피/음료',
  F15 = '패스트푸드',
  F16 = '한식',
}

export const CONST_KB_MEDIUM_CATEGORY_KOREAN = Object.values(
  KB_MEDIUM_CATEGORY_KOREAN,
);

export enum PICKCOOK_POPUP {
  EVENT = 'EVENT',
  REG_SERVICE_UPDATE = 'REG_SERVICE_UPDATE',
}
export const CONST_PICKCOOK_POPUP = Object.values(PICKCOOK_POPUP);
